{
  "components": {
    "design-system": {
      "navigation": {
        "NavigationBar": {
          "create-account": "Vytvoriť profil",
          "login": "Prihlásiť sa"
        }
      }
    },
    "DonateBlock": {
      "body": "Tetszik a Voksmonitor? Kérjük, támogasd az elkészítését!",
      "title": "Támogasd a Voksmonitor elkészítését!"
    },
    "FooterMultiWord": {
      "body-about-voting-calculator": "A Voksmonitorról",
      "body-comunal-voting": "Komunálné voľby",
      "body-created-by-ngos": "Civil szervezetek együttműködésében készült.",
      "body-data-protection": "Adatvédelem",
      "body-methodoogy": "A Voksmonitor módszertana",
      "body-presidential-voting": "Prezidentské voľby",
      "body-senate-voting": "Senátní volby",
      "body-support-calculator": "A Voksmonitor támogatása",
      "body-who-to-vote": "A Voksmonitor összeveti a véleményedet a pártok programjaival.",
      "links": "Linkek",
      "title-more-about-elections": "További információ a választásokról"
    },
    "QuestionCandidateFilter": {
      "title-candidate-filter": "Szűrés pártok szerint",
      "select-all": "Összes kiválasztása"
    },
    "QuestionTagFilter": {
      "title-filter-by-theme": "Szűrés témák szerint",
      "select-all": "Összes kiválasztása"
    },
    "WantToKnowMore": {
      "more-about-topic": "Bővebben"
    }
  },
  "routes": {
    "comparison": {
      "ComparisonGrid": {
        "answers": "válaszaim",
        "my": "Az én"
      },
      "ComparisonPage": {
        "back-to-main-page": "Vissza a főoldalra",
        "comparison": "Összehasonlítás",
        "my-match": "Egyezéseim",
        "set-comparison": "Összehasonlítás "
      }
    },
    "data-protection": {
      "DataProtectionPage": {
        "title": "Adatvédelem"
      }
    },
    "error": {
      "ErrorPage": {
        "go-to-main-page": "Főoldal",
        "this-page-does-not-exist": "Ez az oldal nem található",
        "unknown-error": "Ismeretlen hiba"
      }
    },
    "guide": {
      "GuidePage": {
        "agree": "Egyetért",
        "back-to-main-page": "Vissza a főoldalra",
        "disagree": "Nem ért egyet",
        "double-weight": "Kétszeres súlyozás",
        "first-question": "Első kérdés",
        "guide": "Útmutató",
        "important": "Fontos számomra",
        "next-step": "Következő lépés",
        "not-included": "Ezt a kérdést nem vesszük figyelembe az eredmények kiszámításánál",
        "previous-step": "Előző lépés",
        "skip": "kihagyás",
        "skip-guide": "Útmutató kihagyása",
        "skip-question": "Amennyiben nincs álláspontod a témáról, vagy nem szeretnél válaszolni, a jobb oldalon található nyíllal továbbléphetsz. A kérdést nem vesszük figyelembe az eredmények kiszámításánál.",
        "text-0": "Amennyiben egy párt nem válaszolt, vagy nincs egyértelmű álláspontja (tartózkodik), úgy a választ nem értékeljük.",
        "text-answer-button": "Válaszlehetőségek",
        "text-important": "Csillaggal jelölhetőek a kitöltő számára fontos témák. Ezeket a program dupla súllyal számítja.",
        "text-method": "Amennyiben egy válasz megegyezik egy párt válaszával, az egy pontot ér. Amennyiben ellentétes a válasz, egy pontot levonunk."
      }
    },
    "index": {
      "IndexPage": {
        "czech-version": {
          "link": "českú verziu",
          "prefix": "Zatiaľ sa môžete pozrieť na {0}",
          "suffix": "volebnej kalkulačky."
        },
        "disclaimer": "A beküldéssel beleegyezel, hogy értesítést kapj a Voksmonitorról.",
        "empty-email-error": "Szükséges mező",
        "error": "Hiba történt :( Kérjük, próbáld újra.",
        "inform-me": "Értesítsen az új Voksmonitorokról",
        "input-label": "E-mail",
        "input-text": "Iratkozz fel és értesítünk, ha új Voksmonitort indítunk.",
        "primary-text": "Prípravujeme pre vás volebnú kalkulačku pre voľby do Národnej rady Slovenskej republiky 2023.",
        "secondary-text": "Add meg az e-mail címed, és értesítést küldünk, ha elérhető a Voksmonitor.",
        "subscribe-button-label": "Feliratkozás",
        "success": "Értesíteni fogunk!",
        "title": "Voksmonitor"
      }
    },
    "profile": {
      "AuthPageVue": {
        "create-it": "Vytvorte si ho",
        "create-profile-email": "Vytvoriť profil pomocou e-mailu",
        "link-title": "Podmienkami ochrany osobných údajov",
        "log-in": "Prihláste sa",
        "notification": "Vaše osobné údaje budú spracovávané za účelom tvorby užívateľského profilu, a to v súlade s",
        "opinion": "Sledujte názorový vývoj vo svojom profile",
        "question-one": "Už máte profil?",
        "question-two": "Ešte nemáte profil?",
        "registration": "Vytvoriť profil",
        "title-close": "Zavrieť",
        "use-email": "Pomocou e-mailu"
      },
      "EmailAuthPageVue": {
        "confirmation": "Zaslať potvrdzovací e-mail",
        "create-profile": "Vytvoriť profil",
        "log-in": "Prihlásiť sa",
        "message": "Zadajte svoju e-mailovú adresu",
        "message-verification-first": "Do e-mailovej schránky Vám zašleme e-mail s overovacím odkazom. Registráciu úspešne dokončíte po kliknutí naň.",
        "message-verification-second": "Do e-mailovej schránky Vám zašleme e-mail s overovacím odkazom.",
        "title-close": "Zavrieť"
      },
      "EmailFormPageVue": {
        "about-spam": "Ak ste e-mail s overovacím odkazom nedostali, skontrolujte prosím zložku spamu alebo nevyžiadanú poštu.",
        "confirm-info": "Potvrďte registráciu na Vašom e-maile",
        "confirm-title": "Registrácia čaká na Vaše potvrdenie",
        "error-email": "E-mailová adresa nie je správnom tvare",
        "error-empty-field": "Pole nesmie byť prázdne",
        "login-info": "Do e-mailovej schránky Vám zašleme e-mail s overovacím odkazom.",
        "login-title": "Prihlásiť sa",
        "notification": "Zadajte svoju emailovú adresu",
        "notification-info": "Potvrďte prihlásenie na Vašom e-maile",
        "notification-title": "Prihlásenie čaká na Vaše potvrdenie",
        "registration-info": "Do e-mailovej schránky Vám zašleme e-mail s overovacím odkazom. Registráciu úspešne dokončíte po kliknutí naň.",
        "registration-title": "Vytvoriť profil",
        "send-confirm": "Zaslať potvrdzovací email",
        "title-back": "Naspäť",
        "title-close": "Zavrieť"
      },
      "ProfilePage": {
        "main-title": "Moje kalkulačky",
        "message": "Žiadne ďalšie vyplnené kalkulačky v roku 2023"
      },
      "ProfileSettingsPage": {
        "button-delete": "Odstrániť profil",
        "button-delete-profile": "Zmazať profil a dáta",
        "button-save": "Uložiť zmeny",
        "button-save-profile": "Ponechať profil a dáta",
        "confirm-delete-profile": "Naozaj chcete zmazať profil?",
        "log-out": "Odhlásiť sa",
        "message-part-one": "Prečítajte si o tom na",
        "message-part-two": "Zásady ochrany dát",
        "notification-delete-profile": "Zmazaním profilu prídete permanentne o uložené kalkulačky.",
        "title-data": "Ako nakladáme s dátami?",
        "title-settings": "Nastavenie profilu"
      },
      "SocialMediaConnectCompponent": {
        "facebook": "Pokračovať cez Facebook",
        "google": "Pokračovať cez Google"
      }
    },
    "question": {
      "QuestionBottomBar": {
        "important-for-me": "Fontos számomra",
        "no": "Nem értek egyet",
        "yes": "Egyetértek"
      },
      "QuestionPage": {
        "back-to-main-page": "Vissza a főoldalra",
        "instructions-long": "Útmutató",
        "instructions-short": "Útmutató",
        "next-question-long": "Következő kérdés",
        "next-question-short": "Következő",
        "previous-question-long": "Előző kérdés",
        "previous-question-short": "Előző",
        "recapitulation-long": "Összegzés",
        "recapitulation-short": "Összegzés",
        "skip-question-long": "Kérdés kihagyása",
        "skip-question-short": "kihagyás"
      }
    },
    "questions-methodology": {
      "QuestionsMethodologyPageVue": {
        "title": "A Voksmonitor módszertana"
      }
    },
    "recap": {
      "RecapPage": {
        "back-to-main-page": "Vissza",
        "display-results": "Eredmények mutatása",
        "hint-text": "Válaszok és súlyozás áttekintése, javítása",
        "questions": "Kérdések",
        "recapitulation": "Összegzés"
      },
      "RecapQuestionCard": {
        "display-details": "Részletek mutatása",
        "important-for-me": "Fontos számomra",
        "no": "Nem értek egyet",
        "without-answer": "Nincs válasz",
        "yes": "Egyetértek"
      }
    },
    "result": {
      "ResultCandidateCard": {
        "display-details": "Részletek mutatása",
        "what-candidate-say": "Mit mondanak a jelöltek magukról?"
      },
      "ResultCardContacts": {
        "contacts": "Kapcsolat"
      },
      "ResultCategory": {
        "hide-candidates": "Jelöltek elrejtése",
        "show-all-candidates": "Minden jelölt mutatása"
      },
      "ResultPage": {
        "back-to-main-page": "Vissza a főoldalra",
        "back-to-start": "Vissza az elejére",
        "candidates-answers": "A jelöltek válaszai",
        "compare-answers": "Válaszok összehasonlítása",
        "display-not-advancing-candidates": "Nem továbbjutó jelöltek mutatása",
        "in-table": "a táblázatban",
        "fill-calc": "Töltsd ki a Voksmonitort",
        "my-match": "Egyezéseim",
        "recapitulation": "Összegzés",
        "share": "Megosztás",
        "something-went-wrong": "Hiba történt :( ",
        "something-went-wrong-text": "Jelenleg nem működik a megosztás",
        "text-and-answer": "és legalább egy kérdés megválaszolása vagy",
        "text-at-least-one-answer": "Az eredmények megtekintéséhez legalább egy kérdés megválaszolandó",
        "text-display-answers": "a jelöltek válaszainak összehasonlítása.",
        "text-in-time": "Sledujte, ako sa Vaše názory a výsledky (ne)menia v čase.",
        "text-save-calc": "kövesd, hogy miként változnak az eredményeid idővel.",
        "text-table": "megtekintheted az összes jelölt válaszát.",
        "you-may": ""
      },
      "ResultShareModal": {
        "share-facebook": "Megosztás Facebookon",
        "share-now": "Megosztás most",
        "share-title": "Voksmonitor2024",
        "share-twitter": "Megosztás a Twitteren",
        "text-copy": "... vagy kattints ide a link másolásához",
        "text-do-it-too": "Ezek az eredményeim, töltsd ki te is!",
        "text-my-match": "A Voksmonitor szerint az alábbiak állnak hozzám a legközelebb:"
      }
    },
    "share": {
      "SharePage": {
        "fill-again": "Kitöltés újból",
        "my-match": "Ez jött ki nekem:",
        "text-fill-again": "A Voksmonitor újbóli kitöltéséhez kattintson a jobb felső sarokban található gombra"
      }
    }
  }
}